// TODO: gross, surely this has been implemented somewhere else in this codebase
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState } from "react";
const truncateAtWordBoundary = (text, maxLength)=>{
    if (text.length <= maxLength) return text;
    // Find the last space before the maxLength
    const truncated = text.substring(0, maxLength);
    const lastSpaceIndex = truncated.lastIndexOf(" ");
    // If no space found, just truncate at maxLength
    if (lastSpaceIndex === -1) return truncated + "…";
    // Truncate at the last space
    return text.substring(0, lastSpaceIndex) + "…";
};
const SUMMARY_MAX_LENGTH = 172;
export const InfoPanelSummaryText = (param)=>{
    let { summary } = param;
    const [expanded, setExpanded] = useState(false);
    if (!summary) return null;
    const isLongSummary = summary.length > SUMMARY_MAX_LENGTH;
    const displayText = !expanded && isLongSummary ? truncateAtWordBoundary(summary, SUMMARY_MAX_LENGTH) : summary;
    return /*#__PURE__*/ _jsxs("div", {
        className: "text-14 text-grey-12",
        "data-testid": "info-panel-summary-text",
        children: [
            displayText,
            isLongSummary && /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx("br", {}),
                    /*#__PURE__*/ _jsx("button", {
                        onClick: ()=>setExpanded(!expanded),
                        type: "button",
                        className: "mb-4 mt-2 block",
                        children: expanded ? "View less" : "View more"
                    })
                ]
            })
        ]
    });
};
InfoPanelSummaryText.displayName = "InfoPanelSummaryText";
